import { HttpErrorResponse } from "@angular/common/http";
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatOption } from "@angular/material/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSelect } from "@angular/material/select";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ReplaySubject, Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { ClienteOutput } from "src/app/@shared/models/cliente.model";
import { requestSalvarCTeConfiguracao } from "src/app/@shared/models/manutencao-envio-cte";
import { ClienteService } from "src/app/services/cliente/cliente.service";
import { ManutencaoEnvioCteService } from "src/app/services/manutencao-envio-cte/manutencao-envio-cte.service";
import { ChipAutocompleteComponent } from "src/app/@shared/components";
import { ModalProdutosComponent } from "./modal-produtos/modal-produtos.component";
import { ModalConfirmacaoComponent } from "src/app/@shared/components/modal-confirmacao/modal-confirmacao.component";

@Component({
  selector: "app-modal-novo-envio-cte",
  templateUrl: "./modal-novo-envio-cte.component.html",
  styleUrls: ["./modal-novo-envio-cte.component.scss"],
})
export class ModalNovoEnvioCteComponent implements OnInit {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoading: boolean = true;
  envioCTEId: any;
  filters: any;
  tipoParams: any = [];

  produtosProvisorios: any = [];
  produtosResponse: any = [];

  opcaoEnvios = [
    { tipoEnvio: "1", descricao: "FTP" },
    { tipoEnvio: "2", descricao: "SFTP" },
  ];

  allSelectedProcessamento: boolean = false;
  allSelectedCTE: boolean = false;
  @ViewChild(ChipAutocompleteComponent) clientesAutocomplete;
  @ViewChild("selectCTE") selectCTE: MatSelect;
  @ViewChild("selectTipoProcessamento") selectTipoProcessamento: MatSelect;

  clientes: ClienteOutput[];
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<ClienteOutput[]>(1);
  public clienteMultiFilter: FormControl = new FormControl();
  private onDestroy = new Subject<void>();
  enableButtonProduct: boolean = false;

  listaTipoProcessamento: any;
  listaTipoEnvioCTE: any;
  listaTipoCTE: any;

  formDadosConfiguracao: FormGroup = new FormGroup({
    basicos: new FormGroup({
      descricaoEnvioXml: new FormControl(""),
      statusEnvioXml: new FormControl(""),
      tipoEnvio: new FormControl(""),
      tempoDelayEnvioXml: new FormControl(""),
      tipoCte: new FormControl([]),
      tipoDeProcessamento: new FormControl([]),
      clienteSelecionado: new FormControl([]),
      produtoSelecionado: new FormControl([])
    }),

    parametros: new FormGroup({}),

  });

  get formDadosBasicos(): FormGroup {
    return <FormGroup>this.formDadosConfiguracao.get('basicos');
  }
  get descricaoEnvioXml() {
    return this.formDadosBasicos.get("descricaoEnvioXml").value;
  }
  get statusEnvioXml() {
    return this.formDadosBasicos.get("statusEnvioXml").value;
  }
  get tipoEnvio() {
    return this.formDadosBasicos.get("tipoEnvio").value;
  }
  get tempoDelayEnvioXml() {
    return this.formDadosBasicos.get("tempoDelayEnvioXml").value;
  }
  get tipoCte() {
    return this.formDadosBasicos.get("tipoCte").value;
  }
  get tipoDeProcessamento() {
    return this.formDadosBasicos.get("tipoDeProcessamento").value;
  }
  get getClienteSelecionado() {
    return this.formDadosBasicos.get("clienteSelecionado").value;
  }

  get clienteSelecionadoControl() {
    return this.formDadosBasicos.get("clienteSelecionado");
  }

  get parametros(): FormGroup {
    return <FormGroup>this.formDadosConfiguracao.get('parametros');
  }

  validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };
  validations = {
    "email-multiple": (item) => {
      var valid = this.validateEmail(item);
      //if (!valid) this.openSnackBar("Item " + item + " não é um e-mail válido!", "OK", 5000, "warning-snackbar");
      return valid;
    }
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public manutencaoEnvioCte: ManutencaoEnvioCteService,
    public clienteService: ClienteService,
    public dialogRef: MatDialogRef<ModalNovoEnvioCteComponent>,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    data ? (this.envioCTEId = data) : (this.envioCTEId = null);
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.esperarCarregarDados();
    this.cdr.detectChanges();
  }

  async esperarCarregarDados() {
    await Promise.all([
      this.consultaTipoCTE(),
      this.consultaTipoProcessamento(),
      this.consultaTipoEnvioCTE(),
      this.listarClientes(),
    ]);
    this.acaoUsuario();
  }

  encodeURI(data: any): string {
    return btoa(JSON.stringify(data));
  }

  updateParams(tipoParams) {
    this.formDadosConfiguracao.controls["parametros"] = new FormGroup({});
    tipoParams.forEach(element => {
      const control = new FormControl(element.valor);
      this.parametros.addControl("param_" + element.envioTipoParamsId, control);
      if (element.paramValidation?.indexOf("multiple"))
        control.valueChanges.subscribe(x => {
          element.valor = x.value;
        });
    });
  }

  public async listarClientes() {
    return this.clienteService.list().toPromise().then((response: ClienteOutput[]) => {
      this.clientes = response.filter(x => x.nome != '').sort((a, b) => (a.nome < b.nome ? -1 : 1));
      this.filteredClientes.next(this.clientes.slice());
      this.clienteMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.clientes, this.clienteMultiFilter, this.filteredClientes, 'nome');
        });
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar clientes, entre em contato com o suporte : ' + (err.error.Protocolo ?? err.error.Message), 'OK', 10000, 'danger-snackbar');
      });
  }

  private filtroGeral(filtro: any, multifilter: any, filtered: any, field: string) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(response => response[field].toLowerCase().indexOf(search) > -1)
    );
  }
  clearFilterClient() {
    this.produtosProvisorios = [];
    this.produtosResponse = [];
  }

  public consultaTipoEnvioCTE() {
    this.manutencaoEnvioCte.consultaListaTipoEnvioCTE().subscribe(
      (response: any) => {
        this.listaTipoEnvioCTE = response;
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar(
          "Erro ao carregar consulta de Tipo Envio CTE, entre em contato com o suporte : " + (err.error.Protocolo ?? err.error.Message),
          "OK",
          10000,
          "danger-snackbar"
        );
      }
    );
  }

  getClienteId(cliente) {
    return cliente.id;
  }

  getClienteDescription(cliente) {
    return `${cliente.nome} (${cliente.id})`;
  }

  public consultaTipoCTE() {
    this.manutencaoEnvioCte.consultaListaTipoCTE().subscribe(
      (response: any) => {
        this.listaTipoCTE = response;
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar(
          "Erro ao carregar consulta de Tipo Envio CTE, entre em contato com o suporte : " + (err.error.Protocolo ?? err.error.Message),
          "OK",
          10000,
          "danger-snackbar"
        );
      }
    );
  }

  public consultaTipoProcessamento() {
    this.manutencaoEnvioCte.consultaListaTipoProcessamento().subscribe(
      (response: any) => {
        this.listaTipoProcessamento = response;
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar(
          "Erro ao carregar consulta de Tipo Envio CTE, entre em contato com o suporte : " + (err.error.Protocolo ?? err.error.Message),
          "OK",
          10000,
          "danger-snackbar"
        );
      }
    );
  }

  public consultaParams() {
    this.manutencaoEnvioCte.consultaListaParams(this.tipoEnvio, this.envioCTEId).subscribe(
      (response: any) => {
        this.updateParams(response);
        this.tipoParams = response;
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar(
          "Erro ao carregar consulta de Tipo Envio CTE, entre em contato com o suporte : " + (err.error.Protocolo ?? err.error.Message),
          "OK",
          5000,
          "danger-snackbar"
        );
      }
    );
  }

  public acaoUsuario() {
    if (this.envioCTEId) {
      return this.carregarDados();
    } else {
      this.isLoading = false;
    }
  }

  public carregarDados() {
    this.formDadosBasicos.get("clienteSelecionado").setValue('');
    this.isLoading = true;
    this.manutencaoEnvioCte
      .consultaDetalhesCTE(this.envioCTEId)
      .subscribe(
        (response: any) => {
          this.formDadosBasicos.get("descricaoEnvioXml").setValue(response.descricao);
          this.formDadosBasicos.get("tempoDelayEnvioXml").setValue(response.horaDelayEnvio == 0 ? '0' : response.horaDelayEnvio);
          this.formDadosBasicos.get("statusEnvioXml").setValue(response.ativo);
          this.formDadosBasicos.get("tipoEnvio").setValue(response.envioTipo);
          this.formDadosBasicos.get("tipoCte").setValue(response.tipoCteIds.map((x) => x.tipoCteId));
          this.formDadosBasicos.get("tipoDeProcessamento").setValue(response.tipoProcessamentoIds.map((x) => x.tipoProcessamentoId));
          this.formDadosBasicos.get("clienteSelecionado").setValue(response.clientesIds.map(c => c.clienteId));
          if (response.clientesIds.length > 0) {
            const clientId = response.clientesIds.map(c => c.clienteId)
            this.formDadosBasicos.get("clienteSelecionado").setValue(clientId.filter((v, i, a) => a.indexOf(v) === i));
            this.produtosResponse = response.clientesIds.map(x => x.produtoID);
            this.produtosProvisorios = this.produtosResponse;
          }
          this.updateParams(response.configuracao);
          this.tipoParams = response.configuracao;
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
        }
      )
      .add(() => (this.isLoading = false));
  }

  modalProdutosCliente(clienteId) {
    const dialogRef = this.dialog.open(ModalProdutosComponent, {
      width: '1050px',
      data: {
        clienteId: clienteId,
        produtos: this.produtosResponse
      }
    });
    dialogRef.afterClosed()
      .pipe(take(1))
      .subscribe(response => {
        if (response === 'cancel') { return; }
        else {
          this.produtosProvisorios = response;
          if (this.produtosProvisorios !== null) {
            this.produtosResponse = [];
            this.produtosResponse.push(this.produtosProvisorios);
          } else { this.produtosResponse = [] }
        }
      });
  }

  toggleAllSelectionCTE() {
    this.allSelectedCTE = !this.allSelectedCTE;
    if (this.allSelectedCTE) {
      this.selectCTE.options.forEach((item: MatOption) => item.select());
    } else {
      this.selectCTE.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  toggleAllSelectionTipoProcessamento() {
    this.allSelectedProcessamento = !this.allSelectedProcessamento;
    if (this.allSelectedProcessamento) {
      this.selectTipoProcessamento.options.forEach((item: MatOption) =>
        item.select()
      );
    } else {
      this.selectTipoProcessamento.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  public salvarDados() {
    let configuracoes = this.tipoParams.map((param, index) => {
      return {
        "envioTipoParamsId": param.envioTipoParamsId,
        "valor": this.parametros.get("param_" + param.envioTipoParamsId)?.value
      };
    });
    this.filters = {
      envioConfiguracaoId: this.envioCTEId,
      descricao: this.descricaoEnvioXml,
      envioTipo: this.tipoEnvio,
      horaDelayEnvio: this.tempoDelayEnvioXml,
      ativo: this.statusEnvioXml === "" ? false : this.statusEnvioXml,
      configuracao: configuracoes,
      tipoCteIds: this.tipoCte.filter((item) => item),
      tipoProcessamentoIds: this.tipoDeProcessamento.filter((item) => item),
      clientesIds: this.getClienteSelecionado,
      produtosId: this.produtosProvisorios === null || undefined ? null : this.produtosProvisorios?.toString()
    } as requestSalvarCTeConfiguracao;
    this.isLoading = true;
    this.manutencaoEnvioCte
      .salvarCTeConfiguracao(this.filters)
      .subscribe(
        (response: any) => {
          if (response) {
            this.dialogRef.close("OK");
            return this.openSnackBar(
              "Dados salvos com sucesso!",
              "OK",
              5000,
              "success-snackbar"
            );
          } else {
            this.openSnackBar(
              "Não foi possível salvar os dados! Tente novamente mais tarde",
              "OK",
              5000,
              "danger-snackbar"
            );
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar(
            "Erro ao salvar configurações, entre em contato com o suporte : " + (err.error.Protocolo ?? err.error.Message),
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      )
      .add(() => {
        this.isLoading = false;
      });
  }

  getControl(id: string) {
    return this.parametros.get("param_" + id);
  }

  setParamValue(selectedItems: any[]) {
    return selectedItems?.join(";");
  }

  modalConfirmacao(texto, callback) {
    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: "540px",
      data: {
        textoCancelar: "Não",
        textoOk: "Sim",
        texto,
      },
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(callback);
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
